const navigationLinks = [
  { to: '/', label: 'Home', end: true, topLevel: true },
  { to: '/about', label: 'About', topLevel: true },
  {
    label: 'Solutions',
    topLevel: true,
    dropdown: [
      { to: '/infrastructure-systems', label: 'Infrastructure Systems' },
      { to: '/network-systems', label: 'Network Systems' },
      { to: '/data-center', label: 'Data Center Solutions' },
      { to: '/information-security', label: 'Information Security' },
      { to: '/virtualization', label: 'Virtualization' }
    ]
  },
  {
    label: 'Services',
    topLevel: true,
    dropdown: [
      { to: '/professional-services', label: 'Professional Services' },
      { to: '/consulting-implementation', label: 'Consulting & Implementation' },
      { to: '/managed-services', label: 'Managed Services' }
    ]
  },
  { to: '/contact', label: 'Contact', topLevel: true },
  { to: '/why-nexus', label: 'Why Nexus IT' },
  { to: '/alliances', label: 'Alliances' }
];

export default navigationLinks;
